import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { getAllDataWithFlag, deleteEventsDataById } from '../../../../services/CommonService';
import moment from 'moment';
import usePagination from '../../../../Utils/usePagination';
import PaginationControls from '../../../../Utils/PaginationControls';
import { exportToExcel } from "../../../../Utils/common-Excel";

const EventList = () => {
    const [events, setEvents] = useState([]);
    const [error, setError] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const navigate = useNavigate();
    const location = useLocation();
    const [startDateFilter, setStartDateFilter] = useState('');
    const [endDateFilter, setEndDateFilter] = useState('');
    const [EventData1, setEventType] = useState([]);
    const [EntryTyep, setEntryType] = useState([]);
    const [ProjectData, setProjectData] = useState([]);
    const [themes, setThemes] = useState([]);

    useEffect(() => {
        const lookup = JSON.parse(localStorage.getItem('lookup'));
        const theme = JSON.parse(localStorage.getItem('themeData'));
        setThemes(theme);
        setEventType(lookup.filter((m) => m.Flag == '10'));
        setEntryType(lookup.filter((m) => m.Flag == '8'));
        fetchEvents();

    }, []);

    const fetchEvents = async () => {
        try {
            const response = await getAllDataWithFlag(6);
            const response1 = await getAllDataWithFlag(5);
            const eventList = response?.data?.event?.filter(m => m?.is_deleted != 1);
            const eventData = eventList?.sort((a, b) => (b?.id - a?.id))
            setEvents(eventData);
            setProjectData(response1.data.project);
            setError(null);
        } catch (err) {
            Swal.fire({
                title: "Error",
                text: err?.response?.data?.message || err?.message,
                icon: "error",
                confirmButtonText: "OK",
            });
        } finally {
        }
    }

    useEffect(() => {
        const today = moment().add(30, 'days').format('YYYY-MM-DD');
        const fifteenDaysAgo = moment().subtract(15, 'days').format('YYYY-MM-DD');
        setEndDateFilter(today);
        setStartDateFilter(fifteenDaysAgo);
    }, []);

    // Search filter
    const filteredEvents = events.filter(event => {
        const matchesSearch = searchTerm
            ? (event.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                event.description?.toLowerCase().includes(searchTerm.toLowerCase()))
            : true;
        const matchesStartDate = startDateFilter
            ? moment(event.event_date).isSameOrAfter(moment(startDateFilter), 'day')
            : true;
        const matchesEndDate = endDateFilter
            ? moment(event.event_date).isSameOrBefore(moment(endDateFilter), 'day')
            : true;
        return matchesSearch && matchesStartDate && matchesEndDate;
    });

    const { currentPage, setCurrentPage, totalPages, paginatedData: filteredData } = usePagination(filteredEvents, itemsPerPage);

    const handleDelete = async (id, eventName) => {
        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to delete "${eventName}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await deleteEventsDataById(id);
                    if (res.status == 200) {
                        Swal.fire('Deleted!', 'Event has been deleted.', 'success');
                        fetchEvents();
                    }

                } catch (err) {
                    Swal.fire({
                        title: "Error",
                        text: err?.response?.data?.message || err?.message,
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }
            }
        });
    };

    const handleViewParticipants = (id) => {
        navigate(`../events/${id}/participants`);
    };

    const handleViewEvidence = (id) => {
        navigate(`../events/${id}/evidence`);
    };

    const getLookupValue = (code, flag) => {
        return (
            EventData1.find((item) => item.LookupCode == code && item.Flag == flag)?.LookupValue || code
        );
    };

    const getLookupEntryValue = (code, flag) => {
        return (
            EntryTyep.find((item) => item.LookupCode == code && item.Flag == flag)?.LookupValue || code
        );
    };

    const getProject = (id) => {
        return ProjectData.find((p) => p.id === id);
    };

    const getThemeName = (themeId) => {
        const theme = themes.find(t => String(t.id) === String(themeId));
        return theme ? theme.theme : themeId; // fallback to ID if not found
    };

    const handleDownloadExcel = () => {
        const parseHTML = (html) => {
            return new DOMParser().parseFromString(html || '', 'text/html').body.textContent || '';
        }
        if (!events || events.length === 0) {
            Swal.fire('No data', 'There is no event data to export.', 'warning');
            return;
        }
        const formatDate = (isoString) => {
            const date = new Date(isoString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        };

        const formatDateTime = (isoString) => {
            const date = new Date(isoString);
            return date.toLocaleString('en-IN', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
        };
        const exportList = events?.filter(m => m?.is_deleted != 1);
        const exportData = exportList?.map((event, index) => {
            const project = getProject(event.project_id);
            return {
                "S.No.": index + 1,
                "Event": event.title,
                "Description": parseHTML(event.description),
                "Start Date": formatDate(event.event_date),
                "End Date": formatDate(event.event_end_date),
                "Time Start": event.event_time,
                "Time End": event.event_end_time || '18:00:00',
                "Event Type": getLookupValue(event.mode, '10'),
                "Virtual Link": event.location_link,
                "Venue": event.venue,
                "Host": event.host,
                "Meeting Place": event.meeting_place,
                "Entry Type": getLookupEntryValue(event.entry_type, '8'),
                "Ticket Price": event.ticket_price,
                "Theme": getThemeName(event.theme),
                "Registered": event.participant_count,
                "No. of Participants": event.number_of_participants || null,
                "Project": project?.title || event.project_id,
                "Organisation": event.organisation,
                "Banner": event.banner,
                "Is Deleted": event.is_deleted,
                "Created On": formatDate(event.created_at),
                "Updated On": formatDate(event.updated_at),
            };
        });

        exportToExcel(exportData, 'EventList', 'Event', 'Event Report', startDateFilter, endDateFilter);
    };

    const formatDate = (d) => {
        if (d) return moment(d).format('DD-MM-YYYY');
        return '';
    }


    if (!events) {
        return <h5>Loading...</h5>
    }

    return (
        <div className="container-fluid mt-4">
            <div className="card shadow">
                <div className="card-header adminCardHeader d-flex justify-content-between text-white">
                    <h4>Event List</h4>
                    <Link to="../addEvents/new">
                        <button
                            className="btn btn-warning btn-sm"
                        >
                            <i className="bi bi-plus-circle me-1"></i>  Add Events
                        </button>
                    </Link>
                </div>
                <div className="card-body">
                    <div className="row mb-2">
                        <div className="col-md-5">
                            <div className="d-flex justify-content-start align-items-center">
                                <label className="me-2">Search:</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setCurrentPage(1); // Reset to first page
                                    }}
                                    style={{ width: '150px' }}
                                />
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center justify-content-end">
                                <label className="me-2">Start Date:</label>
                                <input
                                    type="date"
                                    className="form-control form-control p-2 me-3"
                                    style={{ width: '25%' }}
                                    value={startDateFilter}
                                    onChange={(e) => {
                                        setStartDateFilter(e.target.value);
                                        setCurrentPage(1); // Reset to first page
                                    }}
                                />
                                <label className="me-2">End Date:</label>
                                <input
                                    type="date"
                                    className="form-control form-control p-2 me-3"
                                    style={{ width: '25%' }}
                                    value={endDateFilter}
                                    onChange={(e) => {
                                        setEndDateFilter(e.target.value);
                                        setCurrentPage(1); // Reset to first page
                                    }}
                                />
                                <button className="btn btn-success mb-2" onClick={handleDownloadExcel}>
                                    <i className="bi bi-file-earmark-excel-fill me-1"></i>
                                    Excel
                                </button>
                            </div>
                        </div>
                    </div>

                    {error && <div className="alert alert-danger">{error}</div>}

                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead className="table-primary">
                                <tr className='text-center'>
                                    <th width="50">S.No.</th>
                                    <th className='text-start'>Event</th>
                                    <th width="100">Start Date</th>
                                    <th width="100">End Date</th>
                                    <th width="100">Time Start</th>
                                    <th width="100">Time End</th>
                                    <th width="100">Registered</th>
                                    <th width="100">Evidence</th>
                                    <th width="100">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData?.length > 0 ? (
                                    filteredData?.map((event, index) => (
                                        <tr key={index} >
                                            <td className='text-center'>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                            <td className='text-start'>{event.title}</td>
                                            <td className='text-center'>{formatDate(event.event_date)}</td>
                                            <td className='text-center'>{formatDate(event.event_end_date)}</td>
                                            <td className='text-center'>{event.event_time}</td>
                                            <td className='text-center'>{event.event_end_time || '18:00:00'}</td>
                                            <td className='text-center cursor-pointer' onClick={() => handleViewParticipants(event.id || index)}>
                                                <i className="bi bi-people me-1"></i>{' '}
                                                {event.participant_count || 0}
                                            </td>
                                            <td className='text-center cursor-pointer' onClick={() => handleViewEvidence(event.id || index)}>
                                                <i className="bi bi-images" ></i>
                                            </td>
                                            <td className='text-center'>
                                                <Link to={`../addEvents/${event.id || index}`}>
                                                    <i
                                                        className="bi bi-pencil-fill text-primary me-2"
                                                        style={{ cursor: "pointer" }}
                                                    ></i></Link>
                                                <i
                                                    className="bi bi-trash-fill text-danger"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleDelete(event.id || index, event.title)}
                                                ></i>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" className="text-center">No events found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    {/* Pagination Controls */}
                    <PaginationControls
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        itemsPerPage={itemsPerPage}
                        setItemsPerPage={setItemsPerPage}
                        totalItems={filteredEvents.length}
                    />
                </div>
            </div>
        </div>
    );
};

export default EventList;
